export default {
  popup: {
    new_order: "New Order Received",
    new_issue: "New Order Issue Reported",
    order_id: "Order ID",
    view: "View",
    order: "Order",
    issue: "Issue"
  }
};